<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-04"><i>Certain women made us astonished</i>.</p>
<p class="fm-05"><span class="smallcaps">LUKE 24:22</span></p>
<p class="fm-06"><span class="smallcaps">DAVID</span>: <i>You sound so certain</i>.</p>
<p class="fm-06"><span class="smallcaps">ABIGAIL</span>: <i>I am</i>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter02.vue?187c1d5a